import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { NgIf } from '@angular/common';
import { TokenStorageService } from './services/token-storage.service';
import { MatDialog as MatDialog, MatDialogConfig as MatDialogConfig } from '@angular/material/dialog';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { ErrorhandlingService } from './services/errorhandling.service';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { UserDTO } from './interfaces/user';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { FunctionsService } from './services/functions.service';
import { FormsModule } from '@angular/forms';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HasRoleDirective } from './directives/hasRole';
import { SubscriptionBannerComponent } from './components/subscription-banner/subscription-banner.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MatIconModule, MatSidenavModule, MatDividerModule, MatOptionModule, MatSelectModule, 
    FormsModule, MatToolbarModule, NgIf,
    MatOptionModule, RouterLink, RouterLinkActive, MatSelectModule, MatInputModule, MatSlideToggleModule, 
    MatTooltipModule, HasRoleDirective, SubscriptionBannerComponent
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})


export class AppComponent implements OnInit {
  title = 'YourNotes';
  role: string;
  user: UserDTO;
  isLoggedIn = false;
  isDirty = false;
  showSync = false;
  archived = false;
  hideIntro = false;
  @ViewChild('sidenav') sidenav: MatSidenav;
  envClass = 'prod';

  constructor(public route: ActivatedRoute, private router: Router, public matDialog: MatDialog, private tokenStorageService: TokenStorageService, private errorhandling: ErrorhandlingService,
    public functions: FunctionsService,
    private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.envClass = `env-${environment.name}`;
    this.tokenStorageService.isLoggedIn$.subscribe(isLoggedIn => {
    this.isLoggedIn = isLoggedIn;
    if (isLoggedIn) {
      this.user = this.tokenStorageService.getUser();
    }
  });
  }

  ngAfterViewInit() {
    this.changeDetectorRef.detectChanges();
  }

  logout(): void {
    this.tokenStorageService.signOut();
    this.isLoggedIn = false;
    this.router.navigate(['home']);
    this.sidenav?.close();
  }

  loginModal() {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = "modal-component";
    dialogConfig.height = "330px";
    dialogConfig.width = "480px";
    const modalDialog = this.matDialog.open(LoginComponent, dialogConfig).afterClosed()
      .subscribe(response => {
        if (response.data == true) {
          this.isLoggedIn = true;
          this.user = this.tokenStorageService.getUser();
          this.router.navigate(["dashboard"], {queryParams: { showWelcomePopup: true }});
          this.sidenav?.close();
        }
      });;
  }

  registerModal() {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = "modal-component";
    dialogConfig.height = "350px";
    dialogConfig.width = "480px";
    const modalDialog = this.matDialog.open(RegisterComponent, dialogConfig);
  }

}

